import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { axios } from "./axios";

export type IBatchPatchSocialApplyBody = {
  ids: ObjectId[];
};

export const useBatchPatchSocialApply = () => {
  const [state, execute, cancel] = axios<void, IBatchPatchSocialApplyBody, unknown>(
    {
      url: "/applies/social/batch",
      method: "PATCH",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (data: IBatchPatchSocialApplyBody) => {
      return execute({
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
